export enum BrandingIds {
  CUPRA = 'dfa67829-5e0e-4ab0-b6b2-acba1fbd0792',
  FORD = '1234',
  TOYOTA = '4567'
}
